import { render, staticRenderFns } from "./pathwayIncentives.vue?vue&type=template&id=2f041dbf&scoped=true"
import script from "./pathwayIncentives.vue?vue&type=script&lang=js"
export * from "./pathwayIncentives.vue?vue&type=script&lang=js"
import style0 from "./pathwayIncentives.vue?vue&type=style&index=0&id=2f041dbf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f041dbf",
  null
  
)

export default component.exports